module.exports = __webpack_public_path__ + "static/media/Lexham Gardens Kitchen (5).eb115509.jpg";